import {
  Avatar,
  Box,
  Center,
  Flex,
  Grid,
  Input,
  Link,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import React from "react";
import HeadingCompo from "../AboutMe/HeadingCompo";
import GlassyBox from "../customComponents/GlassyBox";
import Form from "./Form";

const ContactUs = () => {
  return (
    <Box id="Contact">
      <HeadingCompo>Contact</HeadingCompo>
      <Box mt="30px">
        <GlassyBox>
          {/* <Flex flexDirection="row"> */}

          <Box>
            <Form />
          </Box>
          {/* <Box>
              <Grid
                py={{ lg: "30px", md: "15px", sm: "10px" }}
                templateColumns={{
                  lg: "repeat(2, 1fr)",
                  md: "repeat(2, 1fr)",
                  sm: "repeat(2, 1fr)",
                }}
                gap={[3, 2, 2]}
              >
                {CONTACTS.map((el) => (
                  <Flex key={el.id} align="center">
                    <Link href={el.link}>
                      <Tooltip placement="top" hasArrow label={el.label}>
                        <Avatar
                          size={{ lg: "md", md: "md", sm: "xs" }}
                          name={el.name}
                          src={el.image}
                        />
                      </Tooltip>
                    </Link>
                    <Text
                      fontSize={["9px", "12px", "14px"]}
                      ml={{ lg: "6px", md: "6px", sm: "6px" }}
                    >
                      {el.label}
                    </Text>
                  </Flex>
                ))}
              </Grid>
            </Box> */}

          {/* </Flex> */}
        </GlassyBox>
      </Box>
    </Box>
  );
};

const CONTACTS = [
  {
    id: 1,
    link: "#",
    label: "8840904668",
    name: "Faizal Siddiqui",
    image: "./whats-app.png",
  },
  {
    id: 2,
    link: "https://mail.google.com/mail/u/0/#inbox?compose=new",
    label: "faizalsidp@gmail.com",
    name: "faizalsidp@gmail.com",
    image: "./gmail.png",
  },
  {
    id: 3,
    link: "https://www.linkedin.com/in/faizal-siddiqui/",
    label: "faizal-siddiqui",
    name: "faizal-siddiqui",
    image: "./linkedin.png",
  },
  {
    id: 4,
    link: "https://github.com/faizal-siddiqui",
    label: "faizal-siddiqui",
    name: "faizal-siddiqui",
    image: "./github.png",
  },
];

export default ContactUs;
